// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.two-columns {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  & > * {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 1px;
    padding: 5px;
  }

  & > img {
    object-fit: contain;
  }
}
`, "",{"version":3,"sources":["webpack://./frontend/widget/two-columns.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;;EAEf;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".two-columns {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n\n  & > * {\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-basis: 1px;\n    padding: 5px;\n  }\n\n  & > img {\n    object-fit: contain;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
